import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/////For Server///////////
window.$apiBaseUrl = 'https://www.spotlight-management.com/api/';
window.$imageBaseUrl = 'https://www.spotlight-management.com/api/uploads/';

/////For Local///////////
//window.$apiBaseUrl = 'http://localhost/SpotLightAPi/';
//window.$imageBaseUrl = 'http://localhost/SpotLightAPi/uploads/';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
